module.exports = __webpack_public_path__ + "img/5.60b35c4f.jpg";